import ContactHeader from '../components/Headers/ContactHeader.js';
import { ConsultationForm } from '../components/Forms/ConsultationForm.js';
import CallToAction from '../components/Misc/CallToAction';
import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';

function Contact() {
    return (
        <>
            <ContactHeader />            
            <div className="contact-section">
                <div className="contact-section-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="contact-form-wrapper">
                                    <ConsultationForm/>                          
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Love to join us? 
                        <br />
                        Volunteer with us now
                    </>
                }
                buttonText="Volunteer Now"
                buttonLink="/volunteer"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
        </>
    );
}

export default Contact;
